import { MenuItem } from "@mui/material";
import { Participant } from "../../interfaces/interfaces";
import axios from "axios";
import { enqueueSnackbar } from "notistack";
import React from "react";

import { SearchParticipantContext } from "../../context/searchParticipantContext";
import { User, AppContext } from "../../../../context/appContext";
import { endpoints } from "../../../../endpoints/endpoints";

const ChangeStatus = ({
  participant,
}: {
  participant: Participant;
}): React.JSX.Element => {
  const {
    startSearch,
  }: {
    startSearch: () => void;
  } = React.useContext(SearchParticipantContext);

  const {
    user,
    checkSession,
  }: {
    user: User;
    checkSession: (response: any) => void;
  } = React.useContext(AppContext);

  const changeActiveStatus = async (): Promise<void> => {
    await axios
      .post(endpoints.admin.changeActiveStatus, {
        sessionId: user.sessionId,
        participantId: participant.participantId,
        participantStatus: 1,
      })
      .then(async (response) => {
        checkSession(response);
        if (response.data.status === "success") {
          startSearch();
          enqueueSnackbar("Teilnehmer erfolgreich inaktiviert", {
            variant: "success",
          });
        } else {
          enqueueSnackbar("Fehler beim inaktivieren des Teilnehmers", {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        console.error("Error changing participant status", error);
      });
  };
  return (
    <MenuItem disabled={participant.status === 1} onClick={changeActiveStatus}>
      {`Teilnehmer ${
        participant.status === 1 ? "ist bereits inaktiv" : "inaktivieren"
      }`}
    </MenuItem>
  );
};

export default ChangeStatus;
